var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle !== '')?_c('p',{staticClass:"text-muted mb-4"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }